import { getNotRequiredFields } from '../../utils/helper-functions/array-comparison';

const applyTemplate = (template) => {
  if (template) return template;
  return {};
};

const defaultDigitalWalletsData = {
  paymentInstrument: 'card', // EPaymentInstrument.Card
  digitalWalletError: null,
  digitalWalletTokenizedData: null,
  digitalBillingAddress: null,
  cardTokenizationOptions: null,
  isAmountShaking: false,
  isFirstAmountShaking: true,
  picInitiated: false,
  gPayData: {
    isReadyToPay: false,
    isGPayEnabledOnApp: false,
    removeBtnFromDOM: false,
    isTokenizationChecked: !window?.CASHIER_CONFIG,
  },
  applePayData: {
    isReadyToPay: false,
    isApplePayEnabledOnApp: false,
    removeBtnFromDOM: false,
    isTokenizationChecked: !window?.CASHIER_CONFIG,
  }
};

const findTokenizationOption = (cardTokenizationOptions, provider) =>
  Array.isArray(cardTokenizationOptions)
    ? cardTokenizationOptions.find((option) => option?.token_provider === provider)
    : null;

const getDigitalWalletDataByOptions = (state, action) => {
  const cardTokenizationOptions = action.payload?.card_tokenization_options;
  const isCC = action.payload?.payment_method_type === 'cc';

  const googlePayOption = findTokenizationOption(cardTokenizationOptions, 'google_pay');
  const applePayOption = findTokenizationOption(cardTokenizationOptions, 'apple_pay');

  return isCC ? {
    ...state.payInfo.digitalWallets,
    cardTokenizationOptions: {
      google_pay: googlePayOption || null,
      apple_pay: applePayOption || null,
    },
    gPayData: {
      ...state.payInfo.digitalWallets.gPayData,
      isGPayEnabledOnApp: Boolean(googlePayOption?.enabled),
    },
    applePayData: {
      ...state.payInfo.digitalWallets.applePayData,
      isApplePayEnabledOnApp: Boolean(applePayOption?.enabled),
    },
  } : defaultDigitalWalletsData;
}

const changePayInfo = (state, action) => {
  if (state === undefined) {
    return {
      initMethod: false,
      digitalWallets: defaultDigitalWalletsData,
      template: {},
      templateKey: {},
      gatewaySelectionSource: 'unknown',
      checkbox: true,
      required: [],
      waste: [],
      visibleFields: null,
      changedPayData: null,
      manualRedirect: false,
      inputEditorCachedValue: {},
      errorsInfo: {},
      showBdccModal: false,
      showCardValidationModal: false,
      pciPraxisGate: {},
      customerCards: null,
      showGatewayPickerModal: false,
      isNewEditableTemplate: false, // use for additional fields (with key is_editable)
      allMethodsInMaintenance: false,
    };
  }

  switch (action.type) {
    case 'CREATE_CURRENT_GATEWAY':
      return {
        ...state.payInfo,
        initMethod: false,
        templateKey: {},
        template: {},
        checkbox: true,
        visibleFields: null,
        required: [],
        waste: [],
        changedPayData: null,
        manualRedirect: false,
        errorsInfo: {},
        digitalWallets: getDigitalWalletDataByOptions(state, action),
      };
    case 'CREATE_CURRENT_GATEWAY_FROM_AMOUNT_PAGE':
      return {
        ...state.payInfo,
        initMethod: false,
        templateKey: {},
        template: {},
        checkbox: true,
        visibleFields: null,
        required: [],
        waste: [],
        changedPayData: null,
        manualRedirect: false,
        errorsInfo: {},
      };
    case 'SET_GATEWAY_SELECTION_SOURCE':
      return {
        ...state.payInfo,
        gatewaySelectionSource: action.payload,
      };
    case 'APPLY_TEMPLATE':
      const { value, key } = action.payload;
      return {
        ...state.payInfo,
        template: applyTemplate(value),
        templateKey: key,
        isNewEditableTemplate: !key && !value,
        inputEditorCachedValue: {},
      };
    case 'SET_CHECKBOX':
      return {
        ...state.payInfo,
        checkbox: !state.payInfo.checkbox,
      };
    case 'SET_REQUIRED':
      let notRequiredFields = getNotRequiredFields(
        state.payInfo.notRequiredFields,
        state.payInfo.required,
        action.payload,
      );

      return {
        ...state.payInfo,
        required: action.payload,
        notRequiredFields,
      };
    case 'SET_WASTE':
      return {
        ...state.payInfo,
        waste: action.payload,
      };
    case 'CHANGE-PAY-DATA':
      return {
        ...state.payInfo,
        changedPayData: action.payload,
      };
    case 'UPDATE-PAY-DATA':
      return {
        ...state.payInfo,
        changedPayData: {
          ...state.payInfo.changedPayData,
          [action.payload.name]: action.payload.value,
        },
      };
    case 'SET_ADD_FIELDS_INFO':
      return {
        ...state.payInfo,
        ...action.payload,
      };
    case 'INIT_METHOD_STATE':
      return {
        ...state.payInfo,
        waste: action.payload.waste,
        required: action.payload.required,
        type: action.payload.type,
        initMethod: true,
        inputEditorCachedValue: {},
        showBdccModal: false,
        showCardValidationModal: false,
        pciPraxisGate: {},
      };
    case 'SET_INPUT_EDITOR_CACHE_VALUE':
      return {
        ...state.payInfo,
        inputEditorCachedValue: {
          ...state.payInfo.inputEditorCachedValue,
          ...action.payload,
        },
      };
    case 'SET_BDCC_MODAL':
      return {
        ...state.payInfo,
        showBdccModal: !state.payInfo.showBdccModal,
      };
    case 'SET_CARD_VALIDATION_MODAL':
      return {
        ...state.payInfo,
        showCardValidationModal: !state.payInfo.showCardValidationModal,
      };
    case 'SET_PCI_PRAXIS_GATE':
      return {
        ...state.payInfo,
        pciPraxisGate: { ...action.payload },
      };
    case 'SET_CUSTOMER_CARDS':
      return {
        ...state.payInfo,
        customerCards: action.payload,
      };
    case 'SET_GATEWAY_PICKER_MODAL':
      return {
        ...state.payInfo,
        showGatewayPickerModal: action.payload,
      };
    case 'UPDATE_DIGITAL_WALLET':
      return {
        ...state.payInfo,
        digitalWallets: {
          ...state.payInfo.digitalWallets,
          ...action.payload,
        },
      };
    case 'UPDATE_G_PAY_INFO':
      return {
        ...state.payInfo,
        digitalWallets: {
          ...state.payInfo.digitalWallets,
          gPayData: {
            ...state.payInfo.digitalWallets.gPayData,
            ...action.payload,
          },
        },
      };
    case 'UPDATE_APPLE_PAY_INFO':
      return {
        ...state.payInfo,
        digitalWallets: {
          ...state.payInfo.digitalWallets,
          applePayData: {
            ...state.payInfo.digitalWallets.applePayData,
            ...action.payload,
          },
        },
      };
    default:
      return state.payInfo;
  }
};

export { changePayInfo };
